import { createRouter, createWebHistory } from "vue-router"
import { theme } from "@/services/getSiteTheme"
import { routes } from "./routes"

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    if (to.hash && to.name !== "/products/abstractProductCode") {
      return {
        el: to.hash,
        behavior: "smooth",
      }
    }
    if (to.name === "/products/abstractProductCode") {
      return null
    } else {
      return { top: 0 }
    }
  },
})

const PAGE_TITLE_SUFFIX = theme === "default" ? " | SSS Store" : " | Kidpreneurs.Academy"

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem("user")
  const title = to.query.title ? to.query.title : to.meta.title
  document.title = title + PAGE_TITLE_SUFFIX
  if (to.matched.some((record) => record.meta.requiresAuth) && !loggedIn) {
    next({ name: "/login" })
  } else {
    next()
  }
})

export default router
